<template>
    <div @click="() => {$GlobalStore.closeLastModal()}" style="display: flex; align-item: center; gap: 4px; padding-left: 20px; padding-top: 26px; padding-bottom: 14px;">
        <img style="width: 10px; transform: rotate(180deg);" :src="require('@/assets/images/mypage/ico-move.png')" alt="">
        <div style="font-size: 14px; font-weight: 500;">{{subTitle}}</div>
        <div style="position: absolute; font-weight: 600; left: 50%; top: 58%;  transform: translate(-50%, -50%);">{{title}}</div>
    </div>
</template>

<script>
    export default {
        name: 'RecommendationHeader',
        props: {
            title: {
                type: String,
                default: ''
            },
            subTitle: {
                type: String,
                default: '추천 용병'
            }
        }
    }
</script>

<style scoped>

</style>